<template>
    <div :class="[{loading: Import.loading}, 'modal-window width-d']">
        <h3 class="mt0 mb0" style="color:#333;">Import in '{{ $root.PROJECT }}'</h3>
        <hr class="mb25">
        <div class="modal-body">
            <div
                :class="[{}, 'form-container']">
                <form ref="importForm" name="import">
                    <label class="col-xs-12 col-sm-6">
                        Select your previously exported file
                        <tooltip-icon
                            :text="tooltips.file.text"
                            position="right"
                            :shown="tooltips.file.active"
                            classes="small notify"></tooltip-icon>
                    </label>
                    <div class="clearfix mb5"></div>
                    <input type="file"
                        placeholder="eg: list added"
                        ref="ImportFile"
                        name="ImportFile"
                        @change="$store.dispatch('Import/setFile', $event.target.files[0])"
                        class="form-input"
                        style="width:auto">
                    <div class="clearfix mb10"></div>
                    <label class="" style="display:inline-block;margin-right:30px;">
                        <input
                            type="checkbox"
                            v-model="doBackup"
                            style="width:18px;height:18px;display:inline-block;vertical-align:middle;"
                        > Backup <tooltip-icon
                            :text="tooltips.backup.text"
                            position="right"
                            :shown="tooltips.backup.active"
                            classes="small notify"></tooltip-icon>
                        <br>
                    </label>
                    <label class="">
                        <input
                            type="checkbox"
                            v-model="isCleanImport"
                            style="width:18px;height:18px;display:inline-block;vertical-align:middle;"
                        > Clean import <tooltip-icon
                            :text="tooltips.import.text"
                            position="right"
                            :shown="tooltips.import.active"
                            classes="small notify"></tooltip-icon>
                        <br>
                        <br v-if="!(doBackup && Export && Export.limitReached)">
                        <small v-if="doBackup && Export && Export.limitReached" class="error danger">Warning: the backup option will delete the oldest exported archive ({{Export.items[0].Name.split('_')[0]}}), since the export limit is reached.</small>
                        <br v-if="doBackup && Export && Export.limitReached && isCleanImport">
                        <br v-if="!isCleanImport">
                        <small v-if="isCleanImport" class="error danger">Warning: activating clean import will CLEAR EVERYTHING from current project before importing!</small>
                    </label>
                </form>
            </div>
        </div>
        <hr>
        <div class="action text-right">
            <button type="button" class="btn btn-grey cancel-btn" @click="$store.dispatch('closeModal')">Cancel</button>
            &nbsp;&nbsp;
            <button type="button" class="btn btn-green export-btn" @click="$store.dispatch('Import/import', {isCleanImport, doBackup, deleteExportId})">Import</button>
        </div>
    </div>    
</template>
<script>
import { mapState } from 'vuex'
import TooltipIcon from '@/components/TooltipIcon'

const tooltips = {
    file: {
        text: 'Select an archive file previously exported. Warning: any existing page or snippet will be overwritten by those inside the imported archive, provided they match names',
        active: false
    },
    import: {
        text: 'When checked, all pages and snippets from project WILL BE ERASED before importing. This cannot be undone, so you might want to make sure you have an export backup beforehand',
        active: false
    },
    backup: {
        text: 'When checked, the process will firstly create a backup export, before importing your archive file. WARNING: if the export limit is reached, the oldest export entry will be deleted for the new backup export.',
        active: false
    }
}

export default {
    components: {
        'tooltip-icon': TooltipIcon
    },
    data () {
        return {
            archiveFile: null,
            doBackup: true,
            isCleanImport: false,
            tooltips,
        }
    },
    computed: {
        ...mapState([ 'Import', 'Export' ]),
        deleteExportId () {
            return this.Export && this.Export.limitReached ? this.Export.items[0].Id : false
        }
    },
    methods: {
        // setFile (event) {
        //     this.$store.dispatch('Import/setFile', event.target.files[0])
        // },
        // makeImport () {
        //     const data = {}
        //     this.$store.dispatch('Import/import', this.isCleanImport)
        // }
    },
    async beforeMount () {
        await this.$store.dispatch('Export/fetchAll')
    }
}
</script>
<style lang="scss">
</style>